export default {
  de: {
    add: 'Status hinzufügen',
    definitions: 'Definitionen',
    statuses: 'Status',
    name: 'Name',
  },
};
